<div class="favorite">
  <div class="favorites__container">
    <app-my-favorites></app-my-favorites>
    <ng-container *ngIf="!isGuest; else guestStub">
      <router-outlet></router-outlet>
    </ng-container>
  </div>

  <ng-template #guestStub>
    <article class="empty empty--guest">
      <img
        src="assets/ui/images/svg/empty-favorites.svg"
        width="130"
        height="130"
        alt="empty-favorites"
      />
      <h2 class="empty__text empty__text--guest">Keep track of all your favorite stuff</h2>
      <p class="empty__text empty__text--sub">Create an account or log in to get started</p>
      <app-guest-buttons [source]="'my stuff page'" class="empty__guest-buttons"></app-guest-buttons>
    </article>
  </ng-template>
</div>
